import { render, staticRenderFns } from "./newBundleOffers.vue?vue&type=template&id=54e5d0ca&"
import script from "./newBundleOffers.vue?vue&type=script&lang=js&"
export * from "./newBundleOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports